import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getManuals(module = "", search = "", createDateFrom = "", createDateTo = ""): Promise<AxiosResponse<any, any>> {
  const params: any = {};
  if (module) params.module = module;
  if (search) params.search = search;
  if (createDateFrom) params.createDateFrom = createDateFrom;
  if (createDateTo) params.createDateTo = createDateTo;


  return axiosInstance.get(`Manual/ListManuals`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function createManual(formData: FormData): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`Manual/CreateManuals`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function deleteManual(manualId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Manual/SoftdeleteManual/${manualId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function updateManual(manualId: number, formData: FormData): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Manual/UpdateManual/${manualId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function toggleManualVisibility(manualId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Manual/VisibilityManual/${manualId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function downloadManual(manualId: number): Promise<AxiosResponse<any, any>> {
  try {
    const response = await axiosInstance.get(`Manual/DownloadManualFile/${manualId}`, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
      },
    });
    return response;
  } catch (error: any) {
    
    let errorMessage = 'Error al descargar el documento';
    
    if (error.response) {

      if (error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          
          try {
            const errorData = JSON.parse(text);
            errorMessage = errorData.message || errorMessage;
          } catch {
            errorMessage = text || errorMessage;
          }
        } catch (e) {
          console.error('Error leyendo blob:', e);
        }
      } else if (error.response.data && typeof error.response.data === 'object') {
        
        errorMessage = error.response.data.message || errorMessage;
      } else if (typeof error.response.data === 'string') {
        errorMessage = error.response.data || errorMessage;
      }
      
      if (error.response.status === 404) {
        errorMessage = 'Documento no encontrado.';
      } else if (error.response.status === 500) {
        errorMessage = 'Error del servidor al descargar el documento.';
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
        
    const customError = new Error(errorMessage);
    throw customError;
  }


}

export function getManual(manualId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Manual/GetManual/${manualId}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}